import React, { HTMLAttributes } from 'react';
import cn from 'classnames';
import { useHistory } from 'react-router-dom';

import { useResize } from '../../utils/hooks';
import RoundButton from '../UIkit/RoundButton';
import { ISection } from '../DigitalPlatform1/constants';
import RoundButtonArrowMain from '../UIkit/RoundButtonArrowMain';

import style from './CardMobile.module.css';

type Props = {
  el: ISection;
} & HTMLAttributes<HTMLDivElement>;

function CardMobile({ el, ...props }: Props): JSX.Element {
  const history = useHistory();

  const handleClick = () => {
    history.push(`/product/${el.EnName}`);
  };

  return (
    <div className={style.container} {...props}>
      <div>
        <div className={style.imgbox}>{el.Img && <img src={el.Img} alt={el.Name} className={style.img} />}</div>
        <div className={style.title}>{el.Name}</div>
        <div className={style.text}> {el.Product.text}</div>
      </div>
      <div className={style.detailbox} onClick={handleClick}>
        <div className={style.detail}>Подробнее</div>
        <RoundButtonArrowMain className={style.iconbtn} color="main" variant="filled" width={20} height={20} />
      </div>
    </div>
  );
}

export default CardMobile;
